import { render } from "./ItemListFormacio.vue?vue&type=template&id=a1d567dc&scoped=true"
import script from "./ItemListFormacio.vue?vue&type=script&lang=js"
export * from "./ItemListFormacio.vue?vue&type=script&lang=js"

import "./ItemListFormacio.vue?vue&type=style&index=0&id=a1d567dc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1d567dc"]])

export default __exports__